import React from 'react';

import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import { toastSuccess, toastError } from 'modules/common/toast';
import { FormInputMobileNumber, FormInput, Button } from 'modules/common/input';
import { getFirstMessage } from 'modules/common/utils';

import { registerSchema } from '../validation';

const INIT_FORM = {
  email_address: '',
  mobile_number: '63',
  password: '',
  password_confirmation: '',
};

function RegisterForm({ onClose }) {
  const [validation, setValidation] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const history = useHistory();

  const rootApi = process.env.REACT_APP_END_POINT;

  const { values, errors, submitForm, setFieldValue } = useFormik({
    validationSchema: registerSchema,
    initialValues: INIT_FORM,
    validateOnChange: validation,
    validateOnBlur: validation,
    onSubmit: (payload) => {
      (async () => {
        try {
          setIsLoading(true);

          await fetch(`${rootApi}/v2/vendors/register`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              ...payload,
            }),
          })
            .then((res) =>
              res.json().then((data) => ({ status: res.status, body: data }))
            )
            .then((res) => {
              const { status, body } = res;

              if (status === 200) {
                setValidation(false);
                toastSuccess(body?.message);
                sessionStorage.setItem(
                  'is_activate_account',
                  values?.email_address
                );
                onClose();
                history.push('/activate-account');
                return;
              }

              toastError(getFirstMessage(body?.errors));
            });
          setIsLoading(false);
        } catch (err) {
          setIsLoading(false);
        }
      })();
    },
  });

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        submitForm();
        setValidation(true);
      }}
      className="space-y-5 flex-1"
      noValidate
      autoComplete="off"
    >
      <div>
        <div className="mb-4">
          <FormInput
            name="business_name"
            value={values?.business_name}
            error={errors?.business_name}
            label="Store Name"
            className="text-sm sm:text-base"
            onSetFieldValue={setFieldValue}
          />
        </div>

        <div className="flex flex-col md:flex-row gap-3 mb-4">
          <div className="flex-1">
            <FormInput
              name="first_name"
              value={values?.first_name}
              error={errors?.first_name}
              label="First Name"
              className="text-sm sm:text-base"
              onSetFieldValue={setFieldValue}
            />
          </div>
          <div className="flex-1">
            <FormInput
              name="last_name"
              value={values?.last_name}
              error={errors?.last_name}
              label="Last Name"
              className="text-sm sm:text-base"
              onSetFieldValue={setFieldValue}
            />
          </div>
        </div>

        <div className="mb-4">
          <FormInputMobileNumber
            name="mobile_number"
            onSetFieldValue={setFieldValue}
            value={values?.mobile_number}
            label="Contact Number"
            className="border rounded w-full p-2 py-2.5 text-sm text-gray-500"
            error={errors?.mobile_number}
          />
        </div>

        <div className="mb-4 space-y-1">
          <FormInput
            name="email_address"
            type="email"
            value={values?.email_address}
            error={errors?.email_address}
            label="Email"
            className="text-sm sm:text-base"
            onSetFieldValue={setFieldValue}
          />
          <div className="rounded-sm leading-none" style={{ color: '#666' }}>
            <p className="text-[12px] italic text-gray-500">
              This will be used for email verification.
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-3 md:flex-row">
          <div className="w-full">
            <FormInput
              name="password"
              type="password"
              value={values?.password}
              error={errors?.password || errors?.password_passed}
              className="text-sm sm:text-base"
              label="Password"
              onSetFieldValue={setFieldValue}
              withStrengthValidation
              strengthValidationClassName="w-[300px]"
            />
          </div>
          <div className="w-full">
            <FormInput
              name="password_confirmation"
              type="password"
              value={values?.password_confirmation}
              error={errors?.password_confirmation}
              className="text-sm sm:text-base"
              label="Confirm Password"
              onSetFieldValue={setFieldValue}
            />
          </div>
        </div>
      </div>
      <div className="space-y-4">
        <Button
          className="w-full btn primary md"
          isLoading={isLoading}
          label={isLoading ? 'Loading...' : 'Proceed'}
          type="submit"
        />
      </div>
    </form>
  );
}

RegisterForm.defaultProps = {
  onClose: () => {},
};

RegisterForm.propTypes = {
  onClose: PropTypes.instanceOf(Function),
};

export default RegisterForm;
